module.exports = __webpack_public_path__ + "img/img-404.57af0bf8.svg";